import { render, staticRenderFns } from "./TheHotSignVisitNumber.vue?vue&type=template&id=32b31a24&scoped=true&lang=pug&"
import script from "./TheHotSignVisitNumber.vue?vue&type=script&lang=js&"
export * from "./TheHotSignVisitNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b31a24",
  null
  
)

export default component.exports